import { useLanguage } from '../../context/LanguageContext';

export function Footer() {
    const { t } = useLanguage();
    const year = new Date().getFullYear();

    return (
        <footer className="bg-slate-900 dark:bg-slate-950 text-slate-400 py-12">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                    <div className="flex items-center gap-6">
                        <a href="https://github.com/SPablo2191" target="_blank" rel="noreferrer noopener" className="hover:text-blue-400 transition-colors">
                            <i className="bi bi-github text-xl" />
                        </a>
                        <a href="https://www.linkedin.com/in/pablo-sandoval-191/" target="_blank" rel="noreferrer noopener" className="hover:text-blue-400 transition-colors">
                            <i className="bi bi-linkedin text-xl" />
                        </a>
                        <a href="https://www.instagram.com/alt_pab/" target="_blank" rel="noreferrer noopener" className="hover:text-blue-400 transition-colors">
                            <i className="bi bi-instagram text-xl" />
                        </a>
                        <a href="https://www.youtube.com/@alt_pab" target="_blank" rel="noreferrer noopener" className="hover:text-blue-400 transition-colors">
                            <i className="bi bi-youtube text-xl" />
                        </a>
                        <a href="https://www.tiktok.com/@alt_pab" target="_blank" rel="noreferrer noopener" className="hover:text-blue-400 transition-colors">
                            <i className="bi bi-tiktok text-xl" />
                        </a>
                    </div>

                    <div className="text-center md:text-right text-sm">
                        <p>&copy; {year} Pablo Sandoval. {t('footer.rights')}</p>
                        <p className="mt-1 text-slate-500">{t('footer.built')}</p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
